export default __webpack_public_path__ + "static/media/reddif.80d94679.svg";